var u = Object.defineProperty;
var k = (t, e, n) => e in t ? u(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var i = (t, e, n) => k(t, typeof e != "symbol" ? e + "" : e, n);
import { aj as g, ak as y, al as b, am as B, an as C, ao as w, ap as O, ag as j, X as x, Z as E, W as D } from "./defaultBlocks-CUZfrbY-.js";
function v(t) {
  const e = P(t);
  let { roots: n, nonRoots: r } = m(e);
  const s = [];
  for (; n.size; ) {
    s.push(n);
    const o = /* @__PURE__ */ new Set();
    for (const c of n) {
      const a = t.get(c);
      if (a)
        for (const l of a) {
          const p = e.get(l);
          if (p === void 0)
            continue;
          const d = p - 1;
          e.set(l, d), d === 0 && o.add(l);
        }
    }
    n = o;
  }
  if (r = m(e).nonRoots, r.size)
    throw new Error(
      `Cycle(s) detected; toposort only works on acyclic graphs. Cyclic nodes: ${Array.from(r).join(", ")}`
    );
  return s;
}
function I(t) {
  const e = A(t);
  return v(e);
}
function P(t) {
  const e = /* @__PURE__ */ new Map();
  for (const [n, r] of t.entries()) {
    e.has(n) || e.set(n, 0);
    for (const s of r) {
      const o = e.get(s) ?? 0;
      e.set(s, o + 1);
    }
  }
  return e;
}
function m(t) {
  const e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
  for (const [r, s] of t.entries())
    s === 0 ? e.add(r) : n.add(r);
  return { roots: e, nonRoots: n };
}
function A(t) {
  const e = /* @__PURE__ */ new Map();
  for (const [n, r] of t.entries()) {
    e.has(n) || e.set(n, /* @__PURE__ */ new Set());
    for (const s of r)
      e.has(s) || e.set(s, /* @__PURE__ */ new Set()), e.get(s).add(n);
  }
  return e;
}
function N() {
  return /* @__PURE__ */ new Map();
}
function f(t, e, n) {
  return t.has(e) || t.set(e, /* @__PURE__ */ new Set()), t.get(e).add(n), t;
}
function R(t) {
  const e = N();
  for (const s of t)
    Array.isArray(s.runsBefore) && s.runsBefore.length > 0 ? s.runsBefore.forEach((o) => {
      f(e, s.key, o);
    }) : f(e, "default", s.key);
  const n = I(e), r = n.findIndex((s) => s.has("default"));
  return (s) => 91 + (n.findIndex((c) => c.has(s)) + r) * 10;
}
function S(t) {
  return t && Object.fromEntries(
    Object.entries(t).filter(([, e]) => e !== void 0)
  );
}
class h {
  constructor(e) {
    // Helper so that you can use typeof schema.BlockNoteEditor
    i(this, "BlockNoteEditor", "only for types");
    i(this, "Block", "only for types");
    i(this, "PartialBlock", "only for types");
    i(this, "inlineContentSpecs");
    i(this, "styleSpecs");
    i(this, "blockSpecs");
    i(this, "blockSchema");
    i(this, "inlineContentSchema");
    i(this, "styleSchema");
    this.opts = e;
    const {
      blockSpecs: n,
      inlineContentSpecs: r,
      styleSpecs: s,
      blockSchema: o,
      inlineContentSchema: c,
      styleSchema: a
    } = this.init();
    this.blockSpecs = n, this.styleSpecs = s, this.styleSchema = a, this.inlineContentSpecs = r, this.blockSchema = o, this.inlineContentSchema = c;
  }
  init() {
    const e = R(
      Object.entries({
        ...this.opts.blockSpecs,
        ...this.opts.inlineContentSpecs,
        ...this.opts.styleSpecs
      }).map(([o, c]) => {
        var a;
        return {
          key: o,
          runsBefore: ((a = c.implementation) == null ? void 0 : a.runsBefore) ?? []
        };
      })
    ), n = Object.fromEntries(
      Object.entries(this.opts.blockSpecs).map(([o, c]) => [
        o,
        g(
          c.config,
          c.implementation,
          c.extensions,
          e(o)
        )
      ])
    ), r = Object.fromEntries(
      Object.entries(this.opts.inlineContentSpecs).map(
        ([o, c]) => {
          var a;
          return typeof c.config != "object" ? [o, c] : [
            o,
            {
              ...c,
              implementation: {
                ...c.implementation,
                node: (a = c.implementation) == null ? void 0 : a.node.extend({
                  priority: e(o)
                })
              }
            }
          ];
        }
      )
    ), s = Object.fromEntries(
      Object.entries(this.opts.styleSpecs).map(([o, c]) => {
        var a;
        return [
          o,
          {
            ...c,
            implementation: {
              ...c.implementation,
              mark: (a = c.implementation) == null ? void 0 : a.mark.extend({
                priority: e(o)
              })
            }
          }
        ];
      })
    );
    return {
      blockSpecs: n,
      blockSchema: Object.fromEntries(
        Object.entries(n).map(([o, c]) => [o, c.config])
      ),
      inlineContentSpecs: S(r),
      styleSpecs: S(s),
      inlineContentSchema: b(
        r
      ),
      styleSchema: y(s)
    };
  }
  /**
   * Adds additional block specs to the current schema in a builder pattern.
   * This method allows extending the schema after it has been created.
   *
   * @param additionalBlockSpecs - Additional block specs to add to the schema
   * @returns The current schema instance for chaining
   */
  extend(e) {
    Object.assign(this.opts.blockSpecs, e.blockSpecs), Object.assign(this.opts.inlineContentSpecs, e.inlineContentSpecs), Object.assign(this.opts.styleSpecs, e.styleSpecs);
    const {
      blockSpecs: n,
      inlineContentSpecs: r,
      styleSpecs: s,
      blockSchema: o,
      inlineContentSchema: c,
      styleSchema: a
    } = this.init();
    return this.blockSpecs = n, this.styleSpecs = s, this.styleSchema = a, this.inlineContentSpecs = r, this.blockSchema = o, this.inlineContentSchema = c, this;
  }
}
const F = B(
  () => ({
    type: "pageBreak",
    propSchema: w(O({})),
    content: "none"
  })
), M = C(
  F,
  {
    parse(t) {
      if (t.tagName === "DIV" && t.hasAttribute("data-page-break"))
        return {};
    },
    render() {
      const t = document.createElement("div");
      return t.setAttribute("data-page-break", ""), {
        dom: t
      };
    },
    toExternalHTML() {
      const t = document.createElement("div");
      return t.setAttribute("data-page-break", ""), {
        dom: t
      };
    },
    runsBefore: []
  }
), L = (t) => t.extend({
  blockSpecs: {
    pageBreak: M()
  }
}), U = async (t) => {
  const e = new FormData();
  return e.append("file", t), (await (await fetch("https://tmpfiles.org/api/v1/upload", {
    method: "POST",
    body: e
  })).json()).data.url.replace(
    "tmpfiles.org/",
    "tmpfiles.org/dl/"
  );
};
function T(t) {
  return "pageBreak" in t.schema.blockSchema;
}
function V(t) {
  const e = [];
  return T(t) && e.push({
    ...t.dictionary.slash_menu.page_break,
    onItemClick: () => {
      j(t, {
        type: "pageBreak"
      });
    },
    key: "page_break"
  }), e;
}
class Z extends h {
  static create(e) {
    return new h({
      blockSpecs: (e == null ? void 0 : e.blockSpecs) ?? D,
      inlineContentSpecs: (e == null ? void 0 : e.inlineContentSpecs) ?? E,
      styleSpecs: (e == null ? void 0 : e.styleSpecs) ?? x
    });
  }
}
export {
  Z as B,
  h as C,
  M as a,
  T as b,
  F as c,
  V as g,
  R as s,
  U as u,
  L as w
};
//# sourceMappingURL=BlockNoteSchema-BLLpev-1.js.map
